import { render, staticRenderFns } from "./TarefaLista.vue?vue&type=template&id=3d74d21b&scoped=true&"
import script from "./TarefaLista.vue?vue&type=script&lang=js&"
export * from "./TarefaLista.vue?vue&type=script&lang=js&"
import style0 from "./TarefaLista.vue?vue&type=style&index=0&id=3d74d21b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d74d21b",
  null
  
)

export default component.exports